export const RolesEndpoints = {
    createRole: {
        method: "post",
        url: "/roles",
    },
    getAllRoles: {
        method: "get",
        url: "/roles",
    },
    getRole: (id) => ({
        method: "get",
        url: `/roles/${id}`,
    }),
    updateRole: (id) => ({
        method: "put",
        url: `/roles/${id}`,
    }),
    deleteRole: (id) => ({
        method: "delete",
        url: `/roles/${id}`,
    }),
}
